import React from "react";
import {ButtonBase, IconButton} from "@mui/material";
import {Close} from "@mui/icons-material";
import AtlasIcon from "../../../components/icons/svg/AtlasIcon.svg?react";
import type {AtlasResponseCard} from "../briefingTypes";
import {BRIEFING} from "../briefingData";
import {useBriefing} from "../briefingState";

/**
 * The Atlas companion column: the deck stays the dominant surface, the
 * conversation is the narrow column. Answers render as cards, never paragraphs;
 * the referenced move card highlights. Collapses only on deliberate dismissal.
 */
export const AtlasCompanion: React.FC = () => {
    const {state, dispatch} = useBriefing();
    const questions = BRIEFING.atlas_panel.seeded_questions;
    const active = state.atlasQuestion !== null ? questions[state.atlasQuestion] : null;

    const renderCard = (rc: AtlasResponseCard, i: number) => {
        if (rc.kind === 'note') {
            return <div key={i} className="db-atlas-card db-atlas-note">{rc.text}</div>;
        }
        return (
            <div key={i} className="db-atlas-card">
                <div className="db-atlas-card-title">{rc.title}</div>
                {rc.rows.map(row =>
                    <div key={row.label} className="db-atlas-row">
                        <span className="db-atlas-row-label">{row.label}</span>
                        <span className="db-atlas-row-value">{row.value}</span>
                    </div>
                )}
            </div>
        );
    };

    return (
        <aside className="db-atlas-panel" aria-label={BRIEFING.atlas_panel.hint_label}>
            <div className="db-atlas-head">
                <AtlasIcon className="db-atlas-mark"/>
                <span className="db-atlas-title">{BRIEFING.atlas_panel.hint_label}</span>
                <IconButton size="small" aria-label="Close Atlas panel" onClick={() => dispatch({type: 'closeAtlas'})}>
                    <Close fontSize="small"/>
                </IconButton>
            </div>

            <div className="db-atlas-questions">
                {questions.map((q, i) =>
                    <ButtonBase
                        key={q.question}
                        className={"db-atlas-question" + (state.atlasQuestion === i ? " active" : "")}
                        onClick={() => dispatch({type: 'selectAtlasQuestion', index: i, highlightOpportunityId: q.highlight_opportunity ?? null})}
                    >
                        {q.question}
                    </ButtonBase>
                )}
            </div>

            {active &&
                <div className="db-atlas-answer">
                    {active.response_cards.map(renderCard)}
                </div>
            }
        </aside>
    );
};
